import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): any {
    if (!value) return '';
    // Ensure proper line breaks and spacing
    const formattedValue = value
      .replace(/\n/g, '<br>') // Convert newlines to <br>
      .replace(/\s{2,}/g, ' ') // Normalize multiple spaces
      .trim();
    return this.sanitizer.bypassSecurityTrustHtml(formattedValue);
  }
}